export const FILE_GET_AFILE_LIST_BEGIN = 'FILE_GET_AFILE_LIST_BEGIN';
export const FILE_GET_AFILE_LIST_SUCCESS = 'FILE_GET_AFILE_LIST_SUCCESS';
export const FILE_GET_AFILE_LIST_FAILURE = 'FILE_GET_AFILE_LIST_FAILURE';
export const FILE_GET_AFILE_LIST_DISMISS_ERROR = 'FILE_GET_AFILE_LIST_DISMISS_ERROR';
export const FILE_SUBMIT_AFILE_BEGIN = 'FILE_SUBMIT_AFILE_BEGIN';
export const FILE_SUBMIT_AFILE_SUCCESS = 'FILE_SUBMIT_AFILE_SUCCESS';
export const FILE_SUBMIT_AFILE_FAILURE = 'FILE_SUBMIT_AFILE_FAILURE';
export const FILE_SUBMIT_AFILE_DISMISS_ERROR = 'FILE_SUBMIT_AFILE_DISMISS_ERROR';
export const FILE_DELETE_AFILE_BEGIN = 'FILE_DELETE_AFILE_BEGIN';
export const FILE_DELETE_AFILE_SUCCESS = 'FILE_DELETE_AFILE_SUCCESS';
export const FILE_DELETE_AFILE_FAILURE = 'FILE_DELETE_AFILE_FAILURE';
export const FILE_DELETE_AFILE_DISMISS_ERROR = 'FILE_DELETE_AFILE_DISMISS_ERROR';
export const FILE_AFILE_MODAL_CHANGE = 'FILE_AFILE_MODAL_CHANGE';
export const FILE_CHOOSE_CURRENT_AFILE = 'FILE_CHOOSE_CURRENT_AFILE';



// WEBPACK FOOTER //
// ./src/features/file/redux/constants.js